import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Wind, LayoutGrid, AirVent, ArrowRight } from 'lucide-react';
const systems = [{
  id: 'ducted',
  title: 'Ducted air conditioning',
  icon: Wind,
  image: 'https://cdn.magicpatterns.com/uploads/74DBnnnPaDiHoNeUuZD5vA/ducted-air-conditoning-accutemp.png',
  description: 'Discreet, hidden air conditioning for offices and commercial interiors where appearance and quiet operation matter.',
  bestFor: ['Offices', 'Retail fitouts', 'Premium commercial spaces'],
  href: '/services/ducted'
}, {
  id: 'cassette',
  title: 'Cassette air conditioning',
  icon: LayoutGrid,
  image: 'https://cdn.magicpatterns.com/uploads/kUteWPqLmbhAZP4Y92BuJK/cassette-detail.png',
  description: 'Ceiling-mounted system with even airflow, ideal for offices, shops and customer-facing commercial spaces.',
  bestFor: ['Open-plan offices', 'Retail', 'Restaurants'],
  href: '/services/cassette'
}, {
  id: 'wall-mounted',
  title: 'Wall mounted air conditioning',
  icon: AirVent,
  image: 'https://cdn.magicpatterns.com/uploads/akgyqHU1pPLUBdVziFo8Cy/wall-mounted-air-conditioning.webp',
  description: 'Practical commercial solution for larger rooms and spaces where wall-mounted installation is the right fit.',
  bestFor: ['Server rooms', 'Meeting rooms', 'Individual offices'],
  href: '/services/wall-mounted'
}];
export function SystemsWeInstall() {
  return <section className="py-24 bg-white" data-id="element-543">
      <div className="container mx-auto px-6" data-id="element-544">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16 max-w-2xl" data-id="element-545">
          <h2 className="text-4xl md:text-5xl font-serif text-primary-dark mb-6" data-id="element-546">
            Systems we install
          </h2>
          <p className="text-lg text-primary-dark/70" data-id="element-547">
            Choose the right system type for your space.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-548">
          {systems.map((system, index) => {
          const Icon = system.icon;
          return <motion.div key={system.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex h-full" data-id="element-549">
                <div className="group flex flex-col h-full bg-white rounded-3xl border border-primary-dark/10 hover:shadow-lg transition-all duration-300 w-full overflow-hidden" data-id="element-550">
                  <div className="aspect-[3/2] w-full overflow-hidden bg-surface flex items-center justify-center" data-id="element-551">
                    {system.image ? <img src={system.image} alt={system.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-552" /> : <div className="text-center px-6" data-id="element-553">
                        <Icon className="w-10 h-10 text-primary-dark/20 mx-auto mb-2" data-id="element-554" />
                        <p className="text-primary-dark/40 text-sm font-medium" data-id="element-555">
                          Image placeholder
                        </p>
                      </div>}
                  </div>
                  <div className="p-8 flex flex-col flex-grow" data-id="element-556">
                    <div className="w-14 h-14 bg-primary-light rounded-2xl flex items-center justify-center text-accent mb-8" data-id="element-557">
                      <Icon className="w-7 h-7" data-id="element-558" />
                    </div>

                    <h3 className="text-2xl font-bold text-primary-dark mb-4 group-hover:text-accent transition-colors" data-id="element-559">
                      {system.title}
                    </h3>

                    <p className="text-primary-dark/70 mb-8 leading-relaxed flex-grow" data-id="element-560">
                      {system.description}
                    </p>

                    <div className="mb-8" data-id="element-561">
                      <div className="text-xs font-bold uppercase tracking-wider text-primary-dark/40 mb-3" data-id="element-562">
                        Best for
                      </div>
                      <div className="flex flex-wrap gap-2" data-id="element-563">
                        {system.bestFor.map((item, i) => <span key={i} className="px-3 py-1 bg-surface rounded-full text-xs font-medium text-primary-dark/80" data-id="element-564">
                            {item}
                          </span>)}
                      </div>
                    </div>

                    <Link to={system.href} className="inline-flex items-center text-sm font-bold text-primary-dark mt-auto group-hover:text-accent transition-colors" data-id="element-565">
                      View system details
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-566" />
                    </Link>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-567">
          <p className="text-primary-dark/70" data-id="element-568">
            Not sure which system? We'll recommend the right setup during your
            site survey.
          </p>
        </motion.div>
      </div>
    </section>;
}